import {Button, notification, Row, Col} from "antd";
import React, {useEffect, useState} from "react";
import {approveOrderService} from "../../../../services/approve-order.service";
import i18n from "../../../../i18n";

export default function ChooseContractType({legalEntityID, shipperCompanyID, needUpdate, onChooseContract, onNeedReapprove, allowContractTypes}) {
    const [contractTypes, setContractTypes] = useState([]);

    useEffect(() => {
        if (legalEntityID && shipperCompanyID) {
            approveOrderService.getContractsTypes(legalEntityID, shipperCompanyID, allowContractTypes)
                .then((resp) => {
                    if(resp.status && resp.status === 'error') {
                        onNeedReapprove(true);
                    } else {
                        setContractTypes(resp);
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: i18n.t('components.notification.titles.getContractsTypes'),
                        description: err,
                    });
                })
        }
    }, [legalEntityID, shipperCompanyID])

    const renderContractTypesButtons = () => {
        return contractTypes.map((value => {
            return (
                <Col lg={8} sm={24}>
                    <Button onClick={() => {onChooseContract(value.type)}} className="small-button typical-btn-green" disabled={value.orderCreated}>
                        {value.name}
                    </Button>
                </Col>
            );
        }))
    };

    return (
        <Row>
            {renderContractTypesButtons()}
        </Row>
    );
}
